module.exports = "/images/veil-12.jpg";